<template>
    <div>
        <div layout="column" layout-align="start start" class="full-width mb20-pc px2-pc pb1-pc mb2-mobile px1-mobile bg-white">
            <div layout="row" layout-align="start center" class="title grey--text text-uppercase font-weight-medium mb2-pc mb1-mobile mt3-pc">{{$t('params.langs')}}
                <v-btn @click="displayFilters = !displayFilters" icon class="hidden-md-and-up ml-1"><i :class="['mdi', displayFilters ? 'mdi-filter-remove' : 'mdi-filter']" style="color: black"></i></v-btn>
            </div>
            <div v-if="!$vuetify.breakpoint. smAndDown || displayFilters" layout="row" layout-wrap layout-align="start center" class="full-width">
                <v-select
                    :label="$t('filters.status')"
                    :hint="$t('filters.status_hint')"
                    persistent-hint
                    solo v-model="filters.is_enabled"
                    :items="listStatus"
                    @change="fetch"
                    class="mr5-pc width-100-mobile"
                >
                </v-select>
                <v-text-field solo :label="$t('filters.keywords')" :hint="$t('filters.langs_hint')" persistent-hint v-model="filters.keywords" @keyup.enter="fetch" class="ml5-pc mr5-pc width-100-mobile"></v-text-field>
                <v-btn depressed class="ml5-pc" color="secondary" @click="fetch" large>{{$t('filters.filter_btn')}}</v-btn>
                {{$t('_.or')}}
                <a href="#" class="ml-2 black--text" @click.prevent="resetFilters">{{$t('filters.reinit')}}</a>
            </div>
        </div>
         <div layout="column" layout-align="start start" class="full-width pt3-pc pb5-pc px2-pc pa1-mobile bg-white">
            <div class="font-weight-bold">
                <span class="secondary--text">{{langs.length}}</span>&nbsp;
                <span v-if="langs.length > 1">
                    <span class="text-lowercase">{{$t('params.langs')}}</span>
                    {{$t('filters.match_pl')}} {{$t('filters.criteria')}}
                </span>
                <span v-else>
                    <span class="text-lowercase">{{$t('params.lang')}}</span>
                    {{$t('filters.match')}} {{$t('filters.criteria')}}
                </span>
            </div>

            <div class="mt-1">
                <v-btn class="ml-0" flat outline color="secondary" :to="{name: 'admin-settings-langs-edit', params: {id: 'new'}}">
                    <span style="text-transform: none">{{$t('params.add_lang_btn')}}</span>
                </v-btn>
            </div>

            <v-data-table :headers="headers" :items="langs"  :pagination.sync="pagination" class="full-width hidden-sm-and-down">
                <template slot="items" slot-scope="{ item }">
                    <td><v-icon :color="item.is_enabled ? 'success' : 'error'">mdi-checkbox-blank-circle-outline</v-icon></td>
                    <td>{{ i18n(item.name) }}</td>
                    <td><v-icon v-if="item.is_sys" color="success">mdi-check</v-icon></td>
                    <td><v-icon v-if="item.translated" color="success">mdi-check</v-icon><v-icon v-else color="warning">mdi-alert</v-icon></td>
                    <td layout="row">
                        <v-btn :title="$t('_.edit')" class="mx-0" icon :to="{name: 'admin-settings-langs-edit', params: {id: item.id}}">
                            <v-icon color="secondary">mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn :title="item.is_enabled ? $t('_.disable') : $t('_.enable')" class="mx-0" icon @click="toggle(item)">
                            <v-icon color="secondary">{{ item.is_enabled ? 'mdi-lock-outline': 'mdi-lock-open-outline' }}</v-icon>
                        </v-btn>
                    </td>
                </template>
            </v-data-table>

            <v-list class="hidden-md-and-up full-width" two-line>
                <v-list-tile v-for="item in langs" :key="item.id">
                    <v-list-tile-avatar style="min-width: 56px"><v-icon :class="{'circle-container': true, 'success': item.is_enabled, 'error': !item.is_enabled}" color="white">mdi-earth</v-icon></v-list-tile-avatar>

                    <v-list-tile-content>
                        <v-list-tile-title class="pl-1">{{ i18n(item.name) }}</v-list-tile-title>
                        <v-list-tile-sub-title>
                            <div layout="row" layout-align="start center">
                                <v-icon v-if="item.is_sys" color="success">mdi-check</v-icon>
                                <v-icon v-else color="error">mdi-close</v-icon>
                                &nbsp;{{$t('langs.interfaces')}}
                            </div>
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title>
                            <div layout="row" layout-align="start center">
                                <v-icon v-if="item.translated" color="success">mdi-check</v-icon>
                                <v-icon v-else color="error">mdi-alert</v-icon>
                                &nbsp;{{$t('params.translations')}}
                            </div>
                        </v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action layout="row" layout-align="center center">
                        <v-btn :title="$t('_.edit')" class="mx-0" icon :to="{name: 'admin-settings-langs-edit', params: {id: item.id}}"><v-icon color="secondary">mdi-pencil</v-icon></v-btn>
                        <v-btn :title="item.is_enabled ? $t('_.disable') : $t('_.enable')" class="mx-0" icon @click="toggle(item)">
                            <v-icon color="secondary">{{ item.is_enabled ? 'mdi-lock-outline': 'mdi-lock-open-outline' }}</v-icon>
                        </v-btn>
                    </v-list-tile-action>
                </v-list-tile>
            </v-list>
        </div>
    </div>
</template>

<script>
    import Params from '@/api/params'
    import I18nMixin from '@/mixins/i18n'

    export default {
        mixins: [I18nMixin],
        data () {
            return {
                pagination: {
                    rowsPerPage: 10,
                    descending: 0,
                    sortBy: "`name.${_locale}`",
                },
                filters: {
                    keywords: null,
                    is_enabled: null,
                    sortBy: 'name'
                },
                langs: [],
                displayFilters: false
            }
        },
        mounted () {
            this.fetch();
            this.pagination.sortBy = 'name.' + this._locale;
        },
        methods: {
            fetch () {
                Params.getList('langs', this.filters).then(res => {
                    this.langs = res.data;
                })
            },

            resetFilters () {
                this.filters = {keywords: null, is_enabled: null, sortBy: 'name'};
                this.fetch();
            },

            toggle (item) {
                if (item.is_enabled) {
                    Params.disable('langs', item.id).then(() => {
                        this.fetch();
                        this.$store.commit('LOAD_LANGS');
                        this.$snotify.success(this.$t('params.lang_disable'))
                    })
                } else {
                    Params.enable('langs', item.id).then(() => {
                        this.fetch();
                        this.$store.commit('LOAD_LANGS');
                        this.$snotify.success(this.$t('params.lang_enable'))
                    })
                }
            }
        },
        computed: {
            headers () {
                return [
                    { text: this.$t('filters.status'), value: 'is_enabled', width: "50px" },
                    { text: this.$t('params.lang'), value: 'name.' + this._locale },
                    { text: this.$t('langs.sys'), value: 'is_sys' },
                    { text: this.$t('params.translations'), value: 'translated' },
                    { text: this.$t('_.actions'), sortable: false, width: "80px" }
                ]
            },
            listStatus () {
                return [
                    { value: null, text: this.$t('filters.status_all') },
                    { value: 1, text: this.$t('filters.status_enabled') },
                    { value: 0, text: this.$t('filters.status_disabled') }
                ]
            }
        }
    }
</script>